import Vue from "vue";
import Vuex from "vuex";
import localFilters from "./modules/localFilters";
import sharedFilters from "./modules/sharedFilters";
import userSettings from "./modules/userSettings";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    localFilters,
    sharedFilters,
    userSettings,
  },
  strict: process.env.NODE_ENV !== "production",
  mutations: {
    initStore(state) {
      let storedUserSettings = localStorage.getItem("userSettings");
      if (storedUserSettings) {
        state.userSettings = Object.assign(
          state.userSettings,
          JSON.parse(storedUserSettings)
        );
      }

      let storedLocalFilters = localStorage.getItem("localFilters");
      if (storedLocalFilters) {
        state.localFilters = JSON.parse(storedLocalFilters);
      }

      let storedSharedFilters = localStorage.getItem("sharedFilters");
      if (storedSharedFilters) {
        state.sharedFilters = JSON.parse(storedSharedFilters);
      }
    },
  },
});

// Detects any changes to the state
store.subscribe((mutation, state) => {
  if (mutation.type.startsWith("userSettings/")) {
    localStorage.setItem("userSettings", JSON.stringify(state.userSettings));

    if (mutation.type === "userSettings/rememberFilters") {
      localStorage.removeItem("localFilters");
      localStorage.removeItem("sharedFilters");
    } else if (mutation.type === "userSettings/syncFilters") {
      localStorage.removeItem("sharedFilters");
    }
  } else if (
    store.getters["userSettings/rememberFilters"] &&
    mutation.type.startsWith("localFilters/")
  ) {
    localStorage.setItem("localFilters", JSON.stringify(state.localFilters));
  } else if (
    store.getters["userSettings/syncFilters"] &&
    mutation.type.startsWith("sharedFilters/")
  ) {
    localStorage.setItem("sharedFilters", JSON.stringify(state.sharedFilters));
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js